import React from 'react';
import {useSelector, useDispatch, connect} from 'react-redux';
import './Navbar.scss';
import '../../../../style/typography.scss';
import '../../../../style/utils.scss';
import logo from '../../../../images/logo-contigo-white.png';
import PropTypes from 'prop-types';
import Avatar from '../../../../assets/icons/Avatar';
import {useHistory, useLocation} from 'react-router-dom';


/**
 * @description
 * @param { object } props no redux
 * @return { * } component
 */
const _Navbar = (props) => {
    const {
        name,
    } = props;
    const isLoggedIn = useSelector((state) => state.login.isLoggedIn);
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();

    const handleAvatarClick = () => {
        if (location.pathname.includes('/v2')) {
            history.push('/config');
        } else {
            history.push('/config');
        }
    };

    return (
        <div className="v2-nav-div-background">
            <img src={logo} className={'v2-header-image'} onClick={() => window.location.href = '/'} alt='logo'/>
            {/* {isLoggedIn &&*/}
            {/*    <IconButton edge="start" className="nb-ib" onClick={() => dispatch(commonAction.toggleSideBar())}>*/}
            {/*        <MenuIcon/>*/}
            {/*    </IconButton>*/}
            {/* }*/}
            <div className={'flex-aligned-justified-center gap-8'}>
                <div className={'flex-aligned-justified-center v2-avatar-icon-container'} onClick={handleAvatarClick}>
                    <Avatar width={'16px'} height={'16px'} color={'white'}/>
                </div>
                <p className={'subtitle-1 color-white'}>{name}</p>
            </div>
        </div>
    );
};
const mapStateToProps = (state) => ({
    name: localStorage.getItem('name'),
});

_Navbar.propTypes = {
    name: PropTypes.string,
};

export default connect(mapStateToProps)(_Navbar);
